module.exports = __webpack_public_path__ + "static/img/6023_phase_function_Paper_PointsHejduk_Prediction.759a85a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6023_phase_function_Paper_PointsHejduk_Prediction.png
// module id = cn5G
// module chunks = 0